import React, { useState } from 'react';
import { Modal, Toast } from 'react-bootstrap';
import { Controller } from "react-hook-form";
import Select from 'react-select';
import TextareaAutosize from "react-textarea-autosize";

const AddCursoModal = ({
	showModalAddCurso,
	setShowModalAddCurso,
	setShowModalAddTopico,
	dataTopicos,
	setIdTopico,
	idTopico,
	customStyles,
	cursoAddFile,
	setCursoAddFile,
	uploadCursoProgress,
	register,
	errors,
	control,
	handleSubmit,
	onSubmitAddCurso
}) => {
	const [toast, setToast] = useState({});
	const [showToast, setShowToast] = useState(false);

	// Função para mostrar mensagens de toast
	const showToastMessage = (header, body, variant = 'light') => {
		setToast({ header, body, variant });
		setShowToast(true);
	};

	// Função para submeter o formulário com feedback de toast
	const handleSubmitWithToast = async (data) => {
		try {
			const result = await onSubmitAddCurso(data);

			if (result && result.success) {
				showToastMessage('Sucesso!', result.message || 'Curso adicionado com sucesso.', 'success');
				setTimeout(() => {
					setShowModalAddCurso(false);
					setIdTopico("");
				}, 2000);
			} else if (result) {
				showToastMessage('Erro!', result.message || 'Erro ao adicionar curso.', 'danger');
			}
		} catch (error) {
			showToastMessage('Erro!', error.message || 'Ocorreu um erro inesperado.', 'danger');
		}
	};

	return (
		<>
            <Toast show={showToast} onClose={() => setShowToast(false)} delay={3000} autohide style={{ position: 'fixed', left: '95%', bottom: '10px', transform: 'translateX(-95%)', zIndex: 9999, padding: 0 }}>
                <Toast.Header>
                    <strong className="mr-auto">{toast.header}</strong>
                </Toast.Header>
                <Toast.Body>{toast.body}</Toast.Body>
            </Toast>

			<Modal
				size="lg"
				show={showModalAddCurso}
				onHide={() => {
					setShowModalAddCurso(false);
					setIdTopico("");
				}}
			>
				<form onSubmit={handleSubmit(handleSubmitWithToast)}>
					<Modal.Header closeButton>
						<span className="fw-semibold fs-4 text-primary">Adicionar Curso</span>
					</Modal.Header>
					<Modal.Body>
						<div className="container">
							<div className="row">
								<div className="col-md-12">
									<div className="body">
										<div className="d-flex">
											<div className="d-flex flex-column w-100">
												<div className="row">

													<div className="col-12 col-md-12">
														<div className="mb-3">
															<label className="form-label text-primary fw-medium">Nome</label>
															<input
																type="text"
																{...register('nome', { required: true })}
																placeholder="Nome do curso"
																className="form-control border-primary"
															/>
															{errors.nome && <span className='text-danger fs-7'>Nome do curso é obrigatório.</span>}
														</div>
													</div>

													<div className="col-12 col-md-12">
														<div className="mb-3">
															<label className="form-label text-primary fw-medium">Descrição</label>
															<TextareaAutosize
																minRows={3}
																{...register('descricao')}
																placeholder="Descrição sobre o curso"
																className="form-control border-primary"
															/>
														</div>
													</div>

													<div className="col-9 col-md-10">
														<div className="mb-3">
															<label className="form-label text-primary fw-medium">Tema</label>
															<Controller
																name="idTopico"
																control={control}
																defaultValue={[]}
																rules={{ required: true }}
																render={({ field }) => (
																	<Select
																		{...field}
																		options={dataTopicos.map((value) => ({
																			value: value.id,
																			label: `${value.nome}`,
																		}))}
																		value={field.value}
																		styles={customStyles}
																		rules={{ required: true }}
																		onChange={value => {
																			field.onChange(value)
																			if (value && value.value) {
																				setIdTopico(value.value)
																			}
																		}}
																		placeholder="Selecione o tema"
																		noOptionsMessage={() => "Nenhum tema encontrado."}
																	/>
																)}
															/>
															{errors.idTopico && <span className='text-danger fs-7'>Selecione um tema.</span>}
														</div>
													</div>

													<div className="col-3 col-md-2">
														<div className="d-flex flex-column h-100">
															<label className="form-label opacity-0">button</label>
															<span
																className="btn btn-outline-primary btn-height-58px mb-3 d-flex align-items-center justify-content-center"
																onClick={() => {
																	setShowModalAddTopico(true);
																	setShowModalAddCurso(false);
																}}
															>
																<i className="bi bi-plus"></i>
															</span>
														</div>
													</div>

													<div className="col-12">
														<div className="mb-3">
															<label className="form-label text-primary fw-medium">Thumbnail</label>
															<label
																htmlFor="thumbnail"
																className={`form-control label-input ${cursoAddFile ? 'border-success bg-success' : 'border-primary bg-primary'} text-white fw-medium text-center`}
															>
																<i className="bi bi-card-image me-2"></i> Enviar Imagem
															</label>
															<Controller
																control={control}
																name="thumbnail"
																rules={{ required: true }}
																render={({ field: { onChange, onBlur, value, ref } }) => (
																	<input
																		id='thumbnail'
																		type="file"
																		onBlur={onBlur}
																		ref={ref}
																		onChange={(e) => {
																			const files = e.target.files;
																			onChange(files);
																			if (files && files.length > 0) {
																				setCursoAddFile(true);
																			} else {
																				setCursoAddFile(false);
																			}
																		}}
																	/>
																)}
															/>
															{errors.thumbnail && <span className='text-danger fs-7'>Imagem do curso é obrigatório.</span>}
														</div>
													</div>

													<div className="col-12">
														<div className="mb-3">
															<label className="form-label text-primary fw-medium">Resumo</label>
															<TextareaAutosize
																minRows={3}
																{...register('resumo')}
																placeholder="Informações gerais sobre o curso"
																className="form-control border-primary"
															/>
														</div>
													</div>

													<div className="col-12">
														<div className="mb-3">
															<label className="form-label text-primary fw-medium">Disponibilidade do curso</label>
															<div className="row g-3">
																<div className="col-md-6">
																	<label className="form-label">De:</label>
																	<input
																		type="date"
																		{...register('dataInicio')}
																		className="form-control border-primary w-100"
																		style={{ minWidth: "100%", width: "100%" }}
																	/>
																</div>
																<div className="col-md-6">
																	<label className="form-label">Até:</label>
																	<input
																		type="date"
																		{...register('dataFinal')}
																		className="form-control border-primary w-100"
																		style={{ minWidth: "100%", width: "100%" }}
																	/>
																</div>
															</div>
														</div>
													</div>

													<div className="col-6">
														<div className="mb-3">
															<label className="form-label text-primary fw-medium">Prazo de validade (em meses)</label>
															<input
																type="number"
																{...register('prazo_validade', { required: true })}
																className="form-control border-primary w-100"
															/>
														{errors.prazo_validade && <span className='text-danger fs-7'>Prazo de validade é obrigatório.</span>}
														</div>
													</div>

													<div className="col-12">
														<div className="mb-3">
															<label className="form-label text-primary fw-medium">Tipo de curso</label>
															<div className="d-flex justify-content-start">
																<div className='me-4'>
																	<label className="form-label d-block text-dark">Híbrido</label>
																	<input
																		type="radio"
																		{...register('tipo', { required: true })}
																		value="misto"
																		className="form-check-input"
																	/>
																</div>
																<div className='me-4'>
																	<label className="form-label d-block text-dark">Online</label>
																	<input
																		type="radio"
																		{...register('tipo', { required: true })}
																		value="online"
																		className="form-check-input"
																	/>
																</div>
																<div className=''>
																	<label className="form-label d-block text-dark">Presencial</label>
																	<input
																		type="radio"
																		{...register('tipo', { required: true })}
																		value="presencial"
																		className="form-check-input"
																	/>
																</div>
															</div>
															{errors.tipo && <span className='text-danger fs-7'>Tipo do curso é obrigatório.</span>}
														</div>
													</div>

												</div>
												<div className="progress col-12 mt-4">
													<div
														className="progress-bar"
														role="progressbar"
														style={{ width: uploadCursoProgress || '0%' }}
														aria-valuenow={uploadCursoProgress || '0'}
														aria-valuemin="0"
														aria-valuemax="100"
													>
														{uploadCursoProgress || '0%'}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<button type="submit" className="btn btn-primary text-white">Salvar</button>
						<button
							type="button"
							className="btn btn-outline-primary text-primary"
							onClick={() => {
								setShowModalAddCurso(false);
								setIdTopico("");
							}}
						>
							Cancelar
						</button>
					</Modal.Footer>
				</form>
			</Modal>
		</>
	);
};

export default AddCursoModal;